import { useLocation, useParams } from "react-router";

import Chat from "./chat2.js";

function Wall(props) {
  const location = useLocation();
  const params = useParams();

  // Determine the context based on the current URL
  const getPageContext = () => {
    const pathname = location.pathname;

    // Try to extract ID from URL params first
    let id = params.id;

    // If params.id is not available, try to extract from pathname directly
    if (!id) {
      // Match patterns like /referral/123, /patient/123/card
      const referralMatch = pathname.match(/\/referral\/([^\/]+)/);
      const patientMatch = pathname.match(/\/patient\/([^\/]+)/);

      if (referralMatch) {
        id = referralMatch[1];
      } else if (patientMatch) {
        id = patientMatch[1];
      }
    }

    if (!id) {
      return null;
    }

    if (pathname.includes('/referral/') && !pathname.includes('/referral/create')) {
      return { type: 'referral', id };
    } else if (pathname.includes('/patient/') && pathname.includes('/card')) {
      return { type: 'patient', id };
    }

    return null;
  };

  const pageContext = getPageContext();

  if (!pageContext) {
    return (
      <div style={{ height: '100%', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="typo-normal-150 text-muted">No notes available for this page</div>
      </div>
    );
  }

  return (
    <>
      {pageContext.type === 'referral' && (
        <Chat
          header={"Referral Chat"}
          referralID={pageContext.id}
        />
      )}

      {pageContext.type === 'patient' && (
        <Chat
          header={"Patient Chat"}
          patientID={pageContext.id}
          scopes={["clinical", "physician", "patient"]}
        />
      )}
    </>
  );
}

export default Wall;
